import React, { useContext, useEffect, useState } from "react";
import { Store } from "../../states/store";
import { Link, useNavigate } from "react-router-dom";
import { Container, Dropdown, Form, InputGroup, Nav, Navbar } from "react-bootstrap";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CiUser } from "react-icons/ci";
import axiosInstance from "../../utils/axiosUtil";
import { toast, ToastContainer } from "react-toastify";
export default function Header({ sidebarHandler }) {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const [show, setShow] = useState(false);
  const [creator,setCreator] = useState('')
  const [admin,setAdmin]= useState('')
  const [loading,setLoading] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  // const { userInfo } = {
  //   userInfo: {
  //     fullname: "Codify",
  //     avatar:
  //       "https://cdn2.iconfinder.com/data/icons/avatars-60/5985/2-Boy-512.png",
  //   },
  // };

   useEffect(()=>{

    const getData = async()=>{
    const {data} =   await axiosInstance.get('/api/admin/get-commission')
       if (data) {
         setAdmin(data?.admin_percent)
         setCreator(data?.creator_percent)
       }
    }
    getData()
  },[])

   const handleSubmit = async ()=>{
    

        try {
           if ((Number(admin) + Number(creator)) != 100) {
             return toast.error('Please enter correct value', {
              position: toast.POSITION.TOP_RIGHT,
            });
           }
           setLoading(true)
           const {data} = await axiosInstance.put('/api/admin/update-commission',{creator_percent:creator,admin_percent:admin})
        setLoading(false)
        toast.success("Commission details updated Successsfully", {
                  position: toast.POSITION.TOP_RIGHT,
                });
       
       handleClose()
        } catch (error) {
          toast.error('Something went wrong', {
                    position: toast.POSITION.TOP_RIGHT,
                  });
        }
       handleClose()

    }
  const signoutHandler = (e) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to Logout?") === true) {
      ctxDispatch({ type: "USER_SIGNOUT" });
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      navigate("/");
    }
  };

  return (
    <>
      {userInfo ? (
        <Navbar className="header">
          <Container fluid className="ps-0">
            <GiHamburgerMenu
              style={{
                fontSize: "1.5rem",
                color: "#fff",
                marginLeft: "1.75rem",
                cursor: "pointer",
              }}
              onClick={() => sidebarHandler()}
            />

            <Nav className="ms-auto">
              <Dropdown align="end">
                <Dropdown.Toggle
                  id="user_profile"
                  className="right-profile-logo"
                >
                  <img
                    src={userInfo.avatar}
                    alt="profile_img"
                    className="dropdown-logo"
                  />
                  {/* <FaUserCircle size={"25px"} /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Header>
                    Signed in as
                    <br />
                    <b>Admin</b>
                  </Dropdown.Header>

                  <Dropdown.Divider />
                  <Dropdown.Item>
                    <Link to="/admin/view-profile/" className="nav-link">
                      <FaUser className="icon-md" /> Profile
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Link  onClick={handleShow} className="nav-link">
                      <FaUser className="icon-md" /> Update Commission
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Link onClick={signoutHandler} to="/" className="nav-link">
                      <FaSignOutAlt className="icon-md" /> Log Out
                    </Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Container>
          <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Commission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form.Label htmlFor="basic-url">Creator Commission</Form.Label>
        <InputGroup className="mb-3">
        
        <InputGroup.Text id="basic-addon1"><CiUser /></InputGroup.Text>
        
        <Form.Control
          placeholder="Creator Commission (percentage)"
          aria-label="Username"
          aria-describedby="basic-addon1"
          value={creator}
          onChange={(e)=>setCreator(e.target.value)}
        />
      </InputGroup>
      <Form.Label htmlFor="basic-url">Admin Commission</Form.Label>
        <InputGroup className="mb-3">
        
        <InputGroup.Text id="basic-addon1"><CiUser /></InputGroup.Text>
        
        <Form.Control
          placeholder="Admin Commission (percentage)"
          aria-label="Username"
          aria-describedby="basic-addon1"
          value={admin}
          onChange={(e)=>setAdmin(e.target.value)}
        />
      </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
           {loading ? 'Updating...' : 'Save Changes'} 
          </Button>
        </Modal.Footer>
      </Modal>
       <ToastContainer />
        </Navbar>
      ) : (
        <></>
      )}
    </>
  );
}
